import styled from 'styled-components'
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';

export const HeroContainer = styled.div`
    background: #0c0c0c;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    height: 800px;
    position: relative;
    z-index: 1;

    :before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: 
        linear-gradient(
            180deg,
            rgba( 0, 0, 0, 0.2) 0%,
            rgba( 0, 0, 0, 0.6) 100%
        ),
        linear-gradient(
            180deg,
            rgba( 0, 0, 0, 0.2) 0%,
            transparent 100%
        );
        z-index: 2;
    }
`;

export const HeroBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    -o-object-fix: cover;
    object-fit: cover;
    background: #232a34;
`;

export const ImgBg = styled.img`
    width: 100%;
    height: 100%;
    -o-object-fix: cover;
    object-fit: cover;
    background: #232a34;
`;

export const HeroContent = styled.div`
    z-index: 3;
    max-width: 1200px;
    position: absolute;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const HeroH1 = styled.h1`
    color: #fff;
    font-size: 48px;
    text-align: center;

    @media screen and (max-width: 768px) {
        font-size: 40px;
    }

    @media screen and (max-witdh: 480px) {
        font-size: 32px
    }
`;

export const HeroP = styled.p`
    margin-top: 24px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    max-width: 800px;

    @media screen and (max-width: 768px) {
        font-size: 24px;
    }

    @media screen and (max-width: 480px) {
        font-size: 18px;
    }
`;

export const HeroBtnWraper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ArrowForward = styled(MdArrowForward)`
    margin-left: 8px;
    font-size: 20px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
    margin-left: 8px;
    font-size: 20px;
`;

export const TimerContainer = styled.div`
    margin-top: 30px;
    border: 1px solid #01bf71;
    border-radius: 3px;
    display: flex;
    margin-top: 3em;
    padding: 3em;
    text-align: center;
    align-items: center;
    flex-direction: row;

    @media screen and (max-width: 768px) {
        padding: 1em;
    }
`;

export const TimerValue = styled.div`
    margin: 1em;

    @media screen and (max-width: 768px) {
        margin: 10px;
    }
`;

export const TimerNumber = styled.p`
    font-size: 3em;
    color: #fff;
    font-family: monospace;
   
    @media screen and (max-width: 768px) {
        font-size: 1em;
    }
`;

export const TimerSmallText = styled.small`
    color: #fff;
`;


export const HeroSmall = styled.small`
    color: #fff;
    margin: 25px;

    @media screen and (max-width: 768px) {
        font-size: 50%;
    }
`;

export const RewardContainer = styled.div`
    margin-top: 30px;
    border: 1px solid #01bf71;
    border-radius: 3px;
    margin-top: 3em;
    padding: 3em;
    text-align: center;
    align-items: center;

    @media screen and (max-width: 768px) {
        padding: 1em;
    }
`;

export const RChow = styled.small`
    color: white;
`;

export const RCpercent = styled.p`
    color: #01bf71;
    font-size: 3em;
    font-weight: bold;
`;

export const RCtext = styled.p`
    color: #01bf71;
`;

export const Link = styled.a`
    color: #01bf71;
    cursor: pointer;
`;